/*
 * @Author: Luis duchanglong@frippler.com
 * @Date: 2022-02-18 10:30:31
 * @LastEditors: Luis duchanglong@frippler.com
 * @LastEditTime: 2022-07-29 11:48:52
 * @FilePath: \mes-web\src\utils\pmRequest.js
 * @Description: PM请求
 */
import axios from "axios";
import { Message } from "element-ui";
import { getPmAccessToken } from "@/utils/cookie";
import { getAccessToken } from "@/utils/cookie";
// axios 初始化
const service = axios.create({
  baseURL: process.env.VUE_APP_API_HOST_URL,
  // baseURL: 'http://192.168.31.66:8080',
  withCredentials: false,
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // },
  timeout: 60000
});
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 每次请求前，向 http 头中插入 Access-Token
    if (getAccessToken()) {
      config.headers["Access-Token"] = getAccessToken();
    }
    return config;
  },
  error => {
    console.log(error + "请求拦截失败");
    Promise.reject(error);
  }
);

// 应答拦截器
service.interceptors.response.use(
  response => response.data,
  error => {
    console.log(error);
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
